
import { Component, Prop, Vue } from 'bits/vue'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'

@Component({
  components: {
    OzIcon,
    OzContainedButton,
  },
})
export default class AuthLoginThirdPartyButton extends Vue {
  OzContainedButtonColorScheme = OzContainedButtonColorScheme

  @Prop({ default: '' }) text!: string
  @Prop({ default: '' }) icon!: string
}
